import { atomWithStorage } from "jotai/utils";
import type { ProductRequiredActionEnum } from "../../../features/products/constants/product-required-action.enum";

export interface IProductRequisitesStore {
  productId: number;
  flow: ProductRequiredActionEnum;
  productSurveyPath: string;
}

const PRODUCT_REQUISITES_STORE_KEY = "product_requisites_store";
const initialValue: IProductRequisitesStore | null = null;

export const productRequisitesStore = atomWithStorage<IProductRequisitesStore | null>(
  PRODUCT_REQUISITES_STORE_KEY,
  initialValue,
  undefined,
  {
    getOnInit: true,
  }
);
